export const environment = {
	API_URL: 'https://api.ibescore.com/ibescore',
	USER_ACTION: 'https://api.ibescore.com/user-actions/v1',
	ORIGIN: 'https://companion.ibescore.com',
	PROD: true,
	LOCAL: false
};
